export const ERROR_MESSAGE = 'Failed to fetch data, please check your API or internet connection';
export const MAX = 100;
export const RANDOM_0_MAX = () => Math.floor(Math.random() * (MAX - 1));

export const CARD_WRAP_SIZE = 300;
export const CARD_FONT_SIZE = CARD_WRAP_SIZE * 0.06;


